import axios from "axios";
import hmacSHA512 from 'crypto-js/hmac-sha512';
import Base64 from 'crypto-js/enc-base64';
import { LogInCall, LogInShare } from "./StoreCall";
//var CryptoJS = require("crypto-js");




var api = "https://api.izttra.com/morenamia-api/";
//var api = "http://localhost"; 
var apigeneral = "";
var x_accesskey = "1081592e5bcf4d20a3233e044a0171f4";
var SecretKey = "116971e670ad4dc6821dd3ea75d7f671";

export async function consumir_api(apis, json = {}, tipo = "post", bandera, isMultipart = false) {
  const dia_ac = new Date();
  let month = "" + (dia_ac.getMonth() + 1),
    day = "" + dia_ac.getDate(),
    year = dia_ac.getFullYear(),
    h = "" + dia_ac.getHours(),
    m = "" + dia_ac.getMinutes(),
    ss = "" + dia_ac.getSeconds();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  if (h.length < 2) h = "0" + h;
  if (m.length < 2) m = "0" + m;
  if (ss.length < 2) ss = "0" + ss;

  let dia_actual = [year, month, day].join("-");
  let hora_actual = [h, m, ss].join(":");
  let fecha = `${dia_actual} ${hora_actual}`;

  const token = Base64.stringify(hmacSHA512(fecha + x_accesskey + apis, SecretKey));

  try {
    let headers = {
      "content-type": isMultipart ? "multipart/form-data" : "application/json"
    };


    if (bandera == "login" || bandera == "recuperarPass") {
      headers["apikey"] = "7Fv9QmA2ZxP8RkT3dEJwYHc4N6L0bS5UeKpMVaBfD1XoCqGnhWtirOyIsu";
    }

    if (bandera !== "login" || bandera !== "recuperarPass") {
      const datos = localStorage.getItem("datosm");
      if (datos) headers["Authorization"] = `Bearer ${datos}`;
    }

    if (bandera === "multipark") {
      const datos = localStorage.getItem("datosm");
      if (datos) headers["Authorization"] = `Bearer ${datos}`;
    }

    let consulta;
    if (tipo === "get") {
      consulta = await axios.get(api + apis, { headers, params: json });
    } else if (tipo === "delete") {
      consulta = await axios.delete(api + apis, { headers, data: json });
    } else if (tipo === "put") {
      consulta = await axios.put(api + apis, json, { headers });
    } else {
      consulta = await axios.post(api + apis, json, { headers });
    }

    return consulta.data;
  } catch (error) {
    return -1;
  }
}




function mensajeerrorconexion() {
  return "Error de conexión, revisa tu conexión a internet"
}


///////////////////////////////////  Login   //////////////////////////////////////////////////////////////

export async function validarlogin(email, pass) {

  var json = { "email": email, "password": pass }
  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/login", json, "post", "login")
    // console.log(JSON.stringify(datos))
    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: ''
      })

      LogInCall(temporal.token);
      LogInShare(JSON.stringify(temporal.user));
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    ////console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export async function recuperarpass(email) {

  var json = { "email": email }
  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/catalogo/usuarios/recuperar-password", json, "post", "recuperarPass")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////

export async function getVntas(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/ventas/lista", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
//////////////////////////////////////////////////////////////////////////////////////////////////
// importar Ventas

export async function importarVentasExcel(file) {
  const resp = [];

  try {
    const form = new FormData();
    form.append("file", file);

    const datos = await consumir_api(
      apigeneral + "api/archivo/importar-ventas",
      form,
      "post",
      null,
      true
    );

    if (datos === -1) {
      resp.push({ code: 1000, message: "Error de conexión, revisa tu conexión a internet" });
      return resp[0];
    }

    if (datos.code === 0) {
      resp.push({ code: 0, message: datos.message || "Success", data: datos.data || [] });
    } else {
      resp.push({ code: datos.code ?? 1, message: datos.message || "Error", data: [] });
    }
  } catch (error) {
    resp.push({ code: 1000, message: "Error de conexión, revisa tu conexión a internet" });
  }

  return resp[0];
}


export async function importSantanderExcel(file) {
  const resp = [];

  try {
    const form = new FormData();
    form.append("file", file);

    const datos = await consumir_api(
      apigeneral + "api/archivo/importar-ventas-santander",
      form,
      "post",
      null,
      true
    );

    if (datos === -1) {
      resp.push({ code: 1000, message: "Error de conexión, revisa tu conexión a internet" });
      return resp[0];
    }

    if (datos.code === 0) {
      resp.push({ code: 0, message: datos.message || "Success", data: datos.data || [] });
    } else {
      resp.push({ code: datos.code ?? 1, message: datos.message || "Error", data: [] });
    }
  } catch (error) {
    resp.push({ code: 1000, message: "Error de conexión, revisa tu conexión a internet" });
  }

  return resp[0];
}
